<script>
import TwButton from '@/components/generic/tw-button.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import fundraiserPagePublicFetchMixin from '@/mixins/fundraiserPagePublicFetchMixin.js'
import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'
import FundraiserPageLeftColumn from '@/components/fundraiser-pages/public/fundraiser-page-left-column.vue'
import FundraiserPageRightColumn from '@/components/fundraiser-pages/public/fundraiser-page-right-column.vue'
import FundraiserPageTopHeader from '@/components/fundraiser-pages/public/fundraiser-page-top-header.vue'
import GrouprevPublicFooter from '@/components/grouprev-public-footer.vue'

export default {
  name: 'FundraiserPageLayoutModernMobile' ,
  components: { GrouprevPublicFooter, FundraiserPageTopHeader, FundraiserPageRightColumn, FundraiserPageLeftColumn, TwContainer, TwButton },
  mixins:[fundraiserPagePublicFetchMixin],
  async mounted() {
    await this.fetchFundraiserPage()
    this.scrollToTop()
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<template>
  <div v-if="fundraiserPage && (fundraiserPage.published || (loggedInUser && loggedInUser.id === fundraiserPage.owner_user_id || loggedInUser.admin || loggedInUser.role_organization))">
    <fundraiser-page-top-header :fundraiser-page="fundraiserPage" />
    <div v-if="fundraiserPage.cover_image_url" class="bg-cover bg-no-repeat bg-center bg-overlay md:min-h-60 lg:min-h-96 flex items-center" :style="`background-image: url('${fundraiserPage.cover_image_url}')`">
      <tw-container class="pt-7 pb-16 lg:py-20 max-w-[1360px]">
        <div class="grid lg:grid-cols-3 gap-8 overflow-hidden items-center">
          <div class="flex flex-col gap-3 md:gap-4 col-span-2 text-white text-center sm:text-left py-5 lg:pr-12">
            <h5 v-if="fundraiser && fundraiser.settings && fundraiser.settings.lock_title" class="text-base lg:text-lg xl:text-xl">
              {{ fundraiserPage.cached.owner_name }} is raising funds for:
            </h5>

            <h1 v-if="fundraiser && fundraiser.settings && fundraiser.settings.lock_title" class="md:text-4xl xl:text-5xl">
              {{ fundraiserPage.cached.fundraiser_title }}
            </h1>
            <h1 v-else class="md:text-4xl xl:text-5xl">
              {{ fundraiserPage.title }}
            </h1>
            <p class="md:text-lg leading-5" v-html="fundraiserPage.short_description" />
            <p v-if="fundraiserPage.cached?.team_name" class="md:text-lg leading-5">
              Part of team <router-link :to="{ name : 'FundraiserTeamPublicPage', params: {fundraiserId: fundraiserPage.fundraiser_id, teamId: fundraiserPage.belongs_to_team_id}}" class="text-amber-600">
                {{ fundraiserPage.cached.team_name }}
              </router-link>
            </p>
          </div>
        </div>
      </tw-container>
    </div>
    <tw-container class="relative max-w-[1360px]">
      <div class="grid lg:grid-cols-3 gap-0">
        <fundraiser-page-right-column :fundraiser-page="fundraiserPage" class="lg:col-span-1 lg:order-last relative -top-10 lg:-top-80" />
        <fundraiser-page-left-column :fundraiser-page="fundraiserPage" class="lg:col-span-2 relative -top-10 lg:static lg:pr-12" />
      </div>
      <grouprev-public-footer class="mb-[200px] lg:mb-8" />
    </tw-container>
  </div>
  <div v-else-if="LoadingFetchingFundraiserPagePublic" class="flex items-center justify-center mt-6">
    <div class="flex items-center justify-center w-40 h-40 border border-gray-200 rounded-lg bg-gray-50  mt-10">
      <div role="status">
        <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin  fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="container mx-auto mt-4 p-4">
      <div class="text-center">
        <div class="text-2xl font-bold">
          This fundraiser is not available
        </div>
        <div class="mt-4">
          <tw-button :to="{name: 'Home'}" size="lg">
            Go back to the home page
          </tw-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
